<template>
    <div id="editor_left">
        <editorNoveloutline></editorNoveloutline>
    </div>
</template>
<script>
import editorNoveloutline from '@/components/hottc/editor_noveloutline.vue' //编辑大纲
export default {
    components: {
        editorNoveloutline, 
    },
    data() {
        return {
        }
    },
}
</script>

<style>
#editor_left {
    flex: 1;
    height: 100%;
    margin-right: 15px;
}
</style>